module.exports = __webpack_public_path__ + "static/img/image051.95bc4b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image051.png
// module id = Ph5d
// module chunks = 1